module.exports = __webpack_public_path__ + "static/media/COTEMAR - HSEQ - COTEPLAY - LOGO V2-11-11 1.97052521.png";